import Container from "react-bootstrap/Container";
import "../../styles/Landing.css";
import "../../styles/CardDetailsLanding.css";
import "../../styles/CareerLanding.css";
import Arrow from "../../assets/arrow3.png";
import { Link } from "react-router-dom";

function CardDetailsLanding(props) {
   return (
      <div className="landing">
         <div className="to-search">
            <Container>
               <div className="row">
                  <div className="title">
                     <h3>
                        {props.name}
                        <Link to="/career" className="back-img">
                           <div className="img">
                              <img src={Arrow} alt="" />
                           </div>
                        </Link>
                     </h3>
                  </div>
               </div>
            </Container>
         </div>
      </div>
   );
}

export default CardDetailsLanding;
